import { LIST_PERMISSION, SAVE_MOBILE_VIEW, SAVE_PERMISSION, SAVE_USER_DETAILS, SAVE_SUB_GROUPS } from "../type.action";

const initState = {
  loading: false,
  list: [],
  error: null,
  isMobile: false,
  userDetails: null,
  subGroups: null,
};

const reducers = (state = initState, { type, values }) => {
  switch (type) {
    case SAVE_PERMISSION:
      return {
        ...state,
        list: values,
        error: null,
      };
    case LIST_PERMISSION:
      return {
        ...state,
      };
    case SAVE_MOBILE_VIEW:
      return { ...state, isMobile: values };
    case SAVE_USER_DETAILS:
      return { ...state, userDetails: values };
    case SAVE_SUB_GROUPS:
      return { ...state, subGroups: values };
    default:
      return {
        ...state,
      };
  }
};

export default reducers;
